export default __webpack_public_path__ + "static/media/reading_robot.35ef24f6.png";